import React from "react";
import { motion } from "framer-motion";

import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";

import {
  FaCalendarCheck,
  FaUmbrellaBeach,
  FaClock,
  FaUserClock,
} from "react-icons/fa";

import ReportCard from "../../components/ReportCard";
import TaskProgressChart from "../../components/TaskProgressChart";
import TaskTable from "../../components/TaskTable";

function TaskReport() {

  const stats = [
    {
      title: "Total Working Days",
      value: 25,
      progress: 60,
      icon: FaCalendarCheck,
      color: "#28a745",
    },
    {
      title: "Total Leave Taken",
      value: 12,
      progress: 40,
      icon: FaUserClock,
      color: "#ffc107",
    },
    {
      title: "Total Holidays",
      value: 6,
      progress: 20,
      icon: FaUmbrellaBeach,
      color: "#dc3545",
    },
    {
      title: "Total Half Days",
      value: 5,
      progress: 25,
      icon: FaClock,
      color: "#0d6efd",
    },
  ];

  const chartData = {
    labels: ["In Progress", "Pending", "On Hold", "Completed"],
    datasets: [
      {
        data: [30, 20, 20, 30],
        backgroundColor: ["#f1c40f", "#3498db", "#9b59b6", "#2ecc71"],
      },
    ],
  };

  return (
    <div className="container-fluid mt-3">

      <div className="d-flex mb-3">
        <h4>TaskReport</h4>

        <Button className="ms-auto" variant="dark" size="sm">
          Export
        </Button>
      </div>

      <motion.div className="row mb-3">
        <Col md={6}>
          <ReportCard stats={stats} />
        </Col>

        <Col md={6}>
          <TaskProgressChart chartData={chartData} />
        </Col>

        <TaskTable />
      </motion.div>
    </div>
  );
}

export default TaskReport;